module.exports = __webpack_public_path__ + "img/ring_g_l_0_0.fc99efa1.png";